<template>
    <details class="dropdown"
            :class="bemFacets"
            :open="isOpen"
            @click.stop>
        <summary class="dropdown--summary" @click.prevent="toggle">
            <div class="dropdown--label">
                {{ label }}
                <div class="dropdown--icon">
                    <ui-icon v-bind="icon"/>
                </div>
            </div>
        </summary>
        <div class="dropdown--collection-wrapper">
            <ul class="dropdown--collection u-reset">
                <li class="dropdown--item" v-for="(item, index) in items" :key="index">
                    <a class="dropdown--link u-reset"
                            :class="getLinkFacets(item.facets)"
                            :target="item.external ? '_blank' : '_self'"
                            :rel="item.external ? 'noopener' : null"
                            :href="item.path"
                            @click="close">
                        <span class="dropdown--link-text">{{ item.label }}</span>
                        <div class="dropdown--link-icon" v-if="item.icon">
                            <ui-icon v-bind="item.icon"/>
                        </div>
                    </a>
                </li>
            </ul>
        </div>
    </details>
</template>

<script>
    import { bemMixin } from '@dreipol/vue-ui/src/mixins';
    import { add as addEvent, remove as removeEvent } from 'bianco.events';
    import UiIcon from '@dreipol/vue-ui/src/components/icon/icon';
    import { subscribe, unsubscribe } from 'util/misc/overlay-tracker';

    // store all the dropdowns that will be opened
    const openDropdowns = new Set();
    // close all the ones that were opened
    const closeOpenDropdowns = () => Array.from(openDropdowns).forEach(dropdown => dropdown.close());

    export default {
        components: {
            UiIcon,
        },
        mixins: [bemMixin('dropdown')],
        props: {
            label: {
                type: String,
                required: true,
            },
            /** @type ILink[] */
            items: {
                type: Array,
                required: true,
            },
            openIcon: {
                type: Object,
                default: () => ({
                    symbol: 'triangle-up-xs',
                    size: 'small',
                }),
            },
            closedIcon: {
                type: Object,
                default: () => ({
                    symbol: 'triangle-down-xs',
                    size: 'small',
                }),
            },
        },
        data() {
            return {
                isOpen: false,
            };
        },
        computed: {
            icon() {
                return this.isOpen ? this.openIcon : this.closedIcon;
            },
        },
        methods: {
            close() {
                this.isOpen = false;
                openDropdowns.delete(this);
                unsubscribe(this);
            },
            open() {
                closeOpenDropdowns();
                this.isOpen = true;

                openDropdowns.add(this);
                subscribe(this, this.close);
            },
            getLinkFacets(facets = []) {
                return facets.map(facet => this.bemAdd(facet, 'link'));
            },
            toggle() {
                if (this.isOpen) {
                    this.close();
                } else {
                    this.open();
                }

                this.$emit('change', this.isOpen);
            },
        },
        mounted() {
            addEvent(window, 'click', this.close);
        },
        beforeDestroy() {
            removeEvent(window, 'click', this.close);
            unsubscribe(this);
        },
    };
</script>
